import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { TranslateMapContext } from '../../contexts/TranslateMapContext';
import {
  SkipIntroButton,
  SkipIntroOverlay,
  SkipIntroStyled,
} from './styles/SkipIntroStyled';
import { SkipIntroButton as NewSkipIntrolButton } from '../newSkin/SkinButtons/SkipIntroButton/SkipIntroButton';

class SkipIntro extends PureComponent {
  static contextType = TranslateMapContext;

  constructor(props) {
    super(props);
    this.state = {
      isOverlayVisible: false,
    };
  }

  handleSkipIntro = (skipIntroText) => {
    this.setState({ isOverlayVisible: true });
    setTimeout(() => {
      this.props.disableLoader(); // Unlock loaders after 2 sec
    }, 3000);
    //setTimeout(() => {
    this.props.skipIntroStart(skipIntroText);
    //}, 300);
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.isSkipIntroSkipped &&
      !prevProps.isSkipIntroSkipped &&
      this.state.isOverlayVisible
    ) {
      this.setState({ isOverlayVisible: false });
    }
  }

  render() {
    const { isShowSkipIntroButton, isMobile, isNewSkin } = this.props;
    const skipIntroText = this.context.getTranslate.skipIntro();

    const { isOverlayVisible } = this.state;

    return (
      <SkipIntroStyled>
        {isShowSkipIntroButton &&
          (isNewSkin ? (
            <NewSkipIntrolButton
              text={skipIntroText}
              onClick={() => this.handleSkipIntro(skipIntroText)}
            />
          ) : (
            <SkipIntroButton
              disable={false}
              onClick={
                isMobile ? null : () => this.handleSkipIntro(skipIntroText)
              }
              onTouchEnd={
                isMobile ? () => this.handleSkipIntro(skipIntroText) : null
              }
              buttonStyle="transparent"
              textSize={isMobile ? 'fs_xxs' : 'fs_md'}
              textColor="white"
              hoverColor="black"
              isMobile={isMobile}
              text={skipIntroText}
            />
          ))}
        <SkipIntroOverlay isVisible={isOverlayVisible} />
      </SkipIntroStyled>
    );
  }
}

export default SkipIntro;

SkipIntro.propTypes = {
  isShowSkipIntroButton: PropTypes.bool.isRequired,
  isSkipIntroSkipped: PropTypes.bool.isRequired,
  skipIntroStart: PropTypes.func.isRequired,
  disableLoader: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
  isNewSkin: PropTypes.bool.isRequired,
};
